const LRUCache = require("lru-cache");
const ms = require("ms");
const reporter = require("./reporter");

const defaultOptions = {
  maxAge: ms(process.env.WBLY_CACHE_TTL || "1m"),
  max: parseInt(process.env.WBLY_MAX_CACHE_ENTRIES || 1000, 10),
};

/**
 * wrap an lru cache implementation with reasonable defaults and add it to the reporter
 * @param options
 * @returns {LRUCache}
 */
const lruCache = (options) => {
  options = {
    ...defaultOptions,
    ...options,
  };
  const cache = new LRUCache(options);

  reporter.add(options.id || "", cache);
  return cache;
};

module.exports = lruCache;
